<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/r7rXHL/images/backcover.jpg?1684515197801" alt="This image is the cover for the book Wanted!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wanted!
      </h1>
      <p class="bookDescription body article font2">
        <p>This rare collection of wanted posters from the American West is a historical treasure. The book's nearly 150 original wanted posters, fugitive notices, and Pinkerton Agency circulars are supplemented by fascinated details about the technology of identification, the history of wanted posters, and the stories behind the crimes, which ranged from horse theft, safe blowing, train robbery, seduction, ''white slavery,'' and murder. Posters for notorious bandits such as Jesse James, Butch Cassidy, and the Sundance Kid are also featured.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barbara Fifer, Martin Kidston
      </h2>
      
      <p class="authorDescription body article">Barbara Fifer is a freelance editor and writer. She is the author of twelve books on history and geography.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farcountry Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6821ab18